import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { ServiceObjectDetailsComponent } from "app/client/serviceObject/location/details/service-object-details.component";
import { CallListModule } from "app/client/components/call/list/call-list.module";
import { ServiceObjectTreeNodeModule } from "app/client/components/serviceObject/tree-node/serviceObject-tree-node.module";
import { TooltipModule, TabsModule, BsDropdownModule  } from "ngx-bootstrap";
import { PlannedServiceShortListModule } from "app/client/components/plannedService/list/plannedService-short-list.module";
import { SelectModule } from "ng2-select";

@NgModule({
  declarations: [
    ServiceObjectDetailsComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    CallListModule,
    SelectModule,
    BsDropdownModule,
    PlannedServiceShortListModule,
    ServiceObjectTreeNodeModule,
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
  ]
})
export class LocationDetailsModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/location/details/service-object-details.module.ts